import { call, put, takeLatest } from "redux-saga/effects";
import {
  ADD_ROLE_REQUEST,
  FETCH_ROLES_REQUEST,
  UPDATE_ROLE_REQUEST,
  DELETE_ROLE_REQUEST,
  FETCH_ROLE_DETAILS_REQUEST,
} from "../RoleTypes/RoleTypes";
import {
  addRoleFailure,
  addRoleSuccess,
  fetchRolesFailure,
  fetchRolesSuccess,
  updateRoleSuccess,
  updateRoleFailure,
  deleteRoleSuccess,
  deleteRoleFailure,
  fetchRoleDetailsSuccess,
  fetchRoleDetailsFailure,
} from "../actions/RolesActions";
import axiosInstance from "../../instance/AxiosInstance";

function* handleAddRole(action) {
  try {
    const response = yield call(
      axiosInstance.post,
      "/roles/insertroles",
      action.payload
    );
    yield put(addRoleSuccess(response.data.message));
  } catch (error) {
    yield put(
      addRoleFailure(error.response?.data?.message || "Failed to add role")
    );
  }
}

function* handleFetchRoles() {
  try {
    const response = yield call(axiosInstance.get, "/roles/getroles");
    // console.log("API Response:", response);

    if (response.status === 200 && response.data?.data) {
      const rolesWithParsedPermissions = response.data.data.map((role) => ({
        ...role,
        permissions:
          typeof role.permissions === "string"
            ? JSON.parse(role.permissions)
            : role.permissions,
      }));
      yield put(fetchRolesSuccess(rolesWithParsedPermissions));
    } else {
      throw new Error("Invalid roles data structure");
    }
  } catch (error) {
    console.error("Error fetching roles:", error.message);
    yield put(fetchRolesFailure(error.message || "Failed to fetch roles"));
  }
}

function* handleUpdateRole(action) {
  try {
    console.log("Updating Role with data:", action.payload);
    console.log(action.payload.id);

    const response = yield call(
      axiosInstance.put,
      `/roles/updateRoles/${action.payload.id}`,
      action.payload
    );

    console.log("Backend response:", response.data);

    let parsedPermissions = {};
    if (response.data.permissions) {
      try {
        parsedPermissions = JSON.parse(response.data.permissions);
      } catch (err) {
        console.error("Error parsing permissions:", err);
      }
    }

    const updatedRole = {
      ...response.data,
      permissions: parsedPermissions,
    };

    yield put(updateRoleSuccess(updatedRole));
  } catch (error) {
    console.error("Error updating role:", error);
    yield put(updateRoleFailure(error.response?.data || error.message));
  }
}

function* handleDeleteRole(action) {
  try {
    const response = yield call(
      axiosInstance.delete,
      `/roles/deleteroles/${action.payload}`
    );
    if (response.status === 200) {
      yield put(deleteRoleSuccess(action.payload));
    } else {
      throw new Error("Failed to delete role");
    }
  } catch (error) {
    yield put(
      deleteRoleFailure(
        error.response?.data?.message || "Failed to delete role"
      )
    );
  }
}

function* handleFetchRoleDetails(action) {
  try {
    const response = yield call(
      axiosInstance.get,
      `/roles/getRole?role_id=${action.payload}`
    );
    console.log("roles", response);
    yield put(fetchRoleDetailsSuccess(response.data));
  } catch (error) {
    yield put(
      fetchRoleDetailsFailure(
        error.response?.data?.message || "Failed to fetch role details"
      )
    );
  }
}

export function* watchFetchRoleDetails() {
  yield takeLatest(FETCH_ROLE_DETAILS_REQUEST, handleFetchRoleDetails);
}

export function* watchDeleteRole() {
  yield takeLatest(DELETE_ROLE_REQUEST, handleDeleteRole);
}
export function* watchUpdateRole() {
  yield takeLatest(UPDATE_ROLE_REQUEST, handleUpdateRole);
}
export function* watchFetchRoles() {
  yield takeLatest(FETCH_ROLES_REQUEST, handleFetchRoles);
}
export function* watchAddRole() {
  yield takeLatest(ADD_ROLE_REQUEST, handleAddRole);
}
